import ScrollToTop from './scroll-to-top/scroll-to-top.vue'
import msalComponent from './msal/msal.vue'
import StarIcon from './star-icon/star-icon.vue'

export default [
  ScrollToTop,
  msalComponent,
  StarIcon
]
